import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query GetBasketData($organisationId: ID!, $schemeType: ID!, $locale: String) {
    storeBasketData(organisationId: $organisationId, schemeType: $schemeType, locale: $locale) {
      employeeOrganisation {
        scheme {
          basket {
            id
            count
            monthlyPrice
            term
            totalMonthlyGrossAmount
            disposalFee
            endOfAgreementFee
            totalSavings
            totalRrp
            headroomValue
            basketItems {
              id
              productId
              brochureGroupId
              name
              link
              quantity
              imageUrl
              price
              totalAmount
              term
              brand
              category
              variant
              sku
              storeName
              department
              supplierName
              status
              releaseDate
            }
          }
        }
      }
    }
  }
`

export const getBasketDataQueryKey = getQueryNames(query)[0]
export default query
